import {
  Component, Input, Output, EventEmitter,
  OnChanges, SimpleChanges, AfterViewInit, OnInit
} from '@angular/core';
import { Subscription } from 'rxjs';

import { DataSource } from '../../lib/data-source/data-source';
import { ValidatorService } from '../../lib/validator.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'ng2-smart-table-pager',
  templateUrl: './pager.component.html',
  styleUrls: ['./pager.component.scss'],
  standalone: false
})
export class PagerComponent implements OnChanges, OnInit {

  @Input() public source: DataSource;
  @Input() public pageNumber: number;
  @Output() public changePage = new EventEmitter<any>();

  public control: FormControl;
  protected dataChangedSub: Subscription;
  protected pages: any[];
  protected page: number;
  protected count: number = 0;
  protected perPage: number;
  private subscription: Subscription;

  constructor(private validator: ValidatorService) {
    this.control = new FormControl([]);
  }

  public ngOnInit() {
    this.subscription = this.validator.notifyObservable$.subscribe((page) => {
      if (page !== -1) {
        this.page = page;
        this.control.setValue(page);
      } else {
        this.control.setValue(this.page);
      }
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.source) {
      if (!changes.source.firstChange) {
        this.dataChangedSub.unsubscribe();
      }
      this.dataChangedSub = this.source.onChanged().subscribe((dataChanges) => {
        this.page = this.source.getPaging().page;
        this.perPage = this.source.getPaging().perPage;
        this.count = this.source.count();
        this.control.setValue(this.page);
        if (this.isPageOutOfBounce()) {
          this.source.setPage(--this.page);
        }
        this.processPageChange(dataChanges);
        this.initPages();
      });
    }
  }

  /**
   * We change the page here depending on the action performed against data source
   * if a new element was added to the end of the table - then change the page to the last
   * if a new element was added to the beginning of the table - then to the first page
   * @param changes
   */
  public processPageChange(changes: any) {
    // if (changes['action'] === 'prepend') {
    //   this.source.setPage(1);
    // }
    // if (changes['action'] === 'append') {
    //   this.source.setPage(this.getLast());
    // }
  }

  public shouldShow(): boolean {
    // return this.source.count() > this.perPage;
    // always show
    return true;
  }

  public paginate(event: Event | number): boolean {
    let page: number;
    if (typeof event === 'number') {
      page = event;
    } else {
      const target = event.target as HTMLSelectElement;
      page = Number(target.value);
    }
    this.changePage.emit({ page });
    return false;
  }

  public getPage(): number {
    return this.page;
  }

  public getPages(): any[] {
    return this.pages;
  }

  public getPageCount(): number {
    if (this.pages) {
      return this.pages.length;
    }
    return 0;
  }

  public getLast(): number {
    return Math.ceil(this.count / this.perPage);
  }

  public getNextPage(): number {
    let page = this.getPage();
    page++;
    return page;
  }

  public getPreviousPage(): number {
    return this.getPage() - 1;
  }

  public isPageOutOfBounce(): boolean {
    return (this.page * this.perPage) >= (this.count + this.perPage) && this.page > 1;
  }

  public initPages() {
    const pagesCount = this.getLast();
    let showPagesCount = 400;
    showPagesCount = pagesCount < showPagesCount ? pagesCount : showPagesCount;
    this.pages = [];

    if (this.shouldShow()) {

      let middleOne = Math.ceil(showPagesCount / 2);
      middleOne = this.page >= middleOne ? this.page : middleOne;

      let lastOne = middleOne + Math.floor(showPagesCount / 2);
      lastOne = lastOne >= pagesCount ? pagesCount : lastOne;

      const firstOne = lastOne - showPagesCount + 1;

      for (let i = firstOne; i <= lastOne; i++) {
        this.pages.push(i);
      }
    }
  }
}
